import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';

/**
 * Returns a function for navigating to the members screen for a team
 */
export const useGotoMembers = () => {
  const history = useHistory();
  return useCallback(
    (teamId: number) => {
      history.push(`/members/${teamId}`);
    },
    [history],
  );
};
